import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGear = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"data-om-id": "jsx:/https:/af5e9daa-29ba-4c52-b212-4edb114d0835.claudeusercontent.com/v1/design/projects/af5e9daa-29ba-4c52-b212-4edb114d0835/serve/js/app.jsx:1758:18:19",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 3.2,
		"data-om-id": "jsx:/https:/af5e9daa-29ba-4c52-b212-4edb114d0835.claudeusercontent.com/v1/design/projects/af5e9daa-29ba-4c52-b212-4edb114d0835/serve/js/app.jsx:1887:18:148"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
		"data-om-id": "jsx:/https:/af5e9daa-29ba-4c52-b212-4edb114d0835.claudeusercontent.com/v1/design/projects/af5e9daa-29ba-4c52-b212-4edb114d0835/serve/js/app.jsx:1921:18:182"
	})]
});
export default SvgGear;
